import { Injectable } from '@angular/core';
import { CanActivate, CanActivateChild, CanLoad, ActivatedRouteSnapshot, Router } from '@angular/router';

import { UserRole } from '@shared/models';

import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root',
})
export class LoggedInGuard implements CanActivate, CanActivateChild, CanLoad {
  constructor(
    private authService: AuthService,
    private router: Router
  ) {}

  canLoad(): boolean {
    if (this.authService.isUserLoggedIn()) {
      return true;
    }
    return false;
  }

  canActivate(route: ActivatedRouteSnapshot): boolean {
    if (!this.authService.isUserLoggedIn()) {
      this.router.navigate(['auth', 'login']);
      return false;
    }

    if (this.authService.isUserInRole(UserRole.Worker)) {
      this.router.navigate(['worker']);
    }

    if (route.data['roles']) {
      return this.authService.isUserInOneOfRoles(route.data['roles']);
    }

    return true;
  }

  canActivateChild(childRoute: ActivatedRouteSnapshot): boolean {
    return this.canActivate(childRoute);
  }
}
